import React from 'react';
import {Range} from 'rc-slider';

const FilterRangeControl = ({
	min,
	max,
	value,
	onChange,
	formatValue,
	fromInput,
	toInput,
	label,
}) => {
	const [from, to] = value;
	const span = max - min || 1;
	const fromPct = ((from - min) / span) * 100;
	const toPct = ((to - min) / span) * 100;

	return (
		<div className="catalog__filter-range-panel">
			<div className="catalog__filter-slider">
				<div className="catalog__filter-slider-tips">
					{
						label
							? <span>{label}</span>
							: (
								<>
									<span style={{left: `${fromPct}%`}}>{formatValue(from)}</span>
									<span style={{left: `${toPct}%`}}>{formatValue(to)}</span>
								</>
							)
					}
				</div>
				<Range
					allowCross={false}
					min={min}
					max={max}
					value={value}
					onChange={onChange}
				/>
				<div className="catalog__filter-slider-bounds">
					<span>{formatValue(min)}</span>
					<span>{formatValue(max)}</span>
				</div>
			</div>
			<div className="catalog__filter-timing">
				{fromInput}
				<span className="catalog__filter-timing-dash" aria-hidden="true"/>
				{toInput}
			</div>
		</div>
	);
};

export default FilterRangeControl;
